import { render } from "./CommunityMessageForm.vue?vue&type=template&id=4f52af00"
import script from "./CommunityMessageForm.vue?vue&type=script&lang=js"
export * from "./CommunityMessageForm.vue?vue&type=script&lang=js"

import "./CommunityMessageForm.vue?vue&type=style&index=0&id=4f52af00&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__